import { useEffect, useState } from "react";
import { Coins } from "lucide-react";
import { api } from "../lib/api";
import { CostCalculator } from "./pricing/CostCalculator";

const ActionRow = ({ a }) => (
  <li className="flex items-center justify-between gap-4 py-2.5 border-b border-amber-500/10 last:border-0" data-testid={`pricing-action-${a.key}`}>
    <span className="text-sm text-slate-300">{a.label}</span>
    <span className="font-mono text-sm text-amber-200 whitespace-nowrap">~{a.credits} cr</span>
  </li>
);

export const PricingGuide = ({ compact = false }) => {
  const [d, setD] = useState(null);
  const [sel, setSel] = useState("books");
  useEffect(() => { api.get("/public/pricing-guide").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === false) return null;
  if (!d) return <div className="h-40" data-testid="pricing-guide-loading" />;
  const f = d.formats.find((x) => x.id === sel) || d.formats[0];
  const pack = d.packs[0];
  return (
    <div className={compact ? "panel p-6 mb-6" : ""} data-testid="pricing-guide">
      <div className="flex flex-wrap gap-2 mb-6" role="tablist">
        {d.formats.map((x) => (
          <button key={x.id} role="tab" aria-selected={x.id === sel} onClick={() => setSel(x.id)} data-testid={`pricing-tab-${x.id}`}
            className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${x.id === sel ? "bg-amber-600 border-amber-400 text-white" : "border-amber-500/30 text-amber-200 hover:bg-amber-500/10"}`}>{x.name}</button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <ul className="bg-slate-900/80 border border-amber-500/20 rounded-xl px-5 py-2" data-testid="pricing-actions">{f.actions.map((a) => <ActionRow key={a.key} a={a} />)}</ul>
        <div className="bg-slate-900/80 border border-amber-500/30 rounded-xl p-6 flex flex-col justify-between" data-testid="pricing-typical">
          <div>
            <p className="eyebrow mb-3 flex items-center gap-2"><Coins size={13} />Typical project</p>
            <p className="text-sm text-slate-300" data-testid="pricing-typical-label">{f.typical.label}</p>
          </div>
          <p className="font-display text-3xl text-amber-100 mt-4" data-testid="pricing-typical-credits">{f.typical.low.toLocaleString()}–{f.typical.high.toLocaleString()} <span className="text-base text-slate-400">credits</span></p>
        </div>
      </div>
      <CostCalculator f={f} packs={d.packs} />
      <p className="text-xs text-slate-500 mt-4" data-testid="pricing-footnote">
        Estimates use current credit prices and vary with length and model. New authors get {d.starter_credits} welcome credits{pack ? `; packs start at ${pack.credits} credits for $${pack.price}` : ""}. You always see a cost estimate before any AI action runs.
      </p>
    </div>
  );
};
